import { LandingData } from "@/types/types";
import styled from "styled-components";
import { MaxWidthContainer as ParentMaxWidthContainer } from "../styles";
import { Colors } from "@/theme";
import { H2 } from "@/components/ui/typography";
import NextImage from "next/image";
import { ButtonRegular } from "@/components/ui/buttons";
import { mobile } from "@/theme/common";
import { Acquisition } from "../Acquisition";
/**
 * Types
 */

interface CallToActionData {
  data: LandingData["sections"]["callToAction"];
  handleRedirectToGame: () => void;
  acquisition?: LandingData["acquisition"];
}

/**
 * Styled Components
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.yellow500};
  width: 100%;
`;

const MaxWidthContainer = styled(ParentMaxWidthContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 48px 0;
  ${mobile(`
    padding: 40px 16px;
  `)}
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const Title = styled(H2)`
  text-align: center;
`;

const Image = styled(NextImage)`
  width: 72px;
  height: auto;
`;

const PrimaryButton = styled(ButtonRegular)`
  background-color: ${Colors.black};
  color: ${Colors.white};
  border-radius: 12px;
`; 

export const CallToActionSection = ({
  data,
  handleRedirectToGame,
  acquisition,
}: CallToActionData) => {
  if (!data) {
    return null;
  }

  return (
    <Container>
      <MaxWidthContainer>
        <Content>
          <Image src={data.image} alt={data.title} width={200} height={200} />
          <Title
            dangerouslySetInnerHTML={{
              __html: data.title,
            }}
          />
        </Content>
        {acquisition ? (
            <Acquisition
              title={acquisition.title}
              description={acquisition.description}
              buttonText={acquisition.buttonText}
              buttonLink={acquisition.buttonLink}
              handleRedirectToGame={handleRedirectToGame}
          />
        ) : (
          <PrimaryButton
            text={data.buttonText}
            onClick={handleRedirectToGame}
            thickBorder="rgba(0, 0, 0, 0.2)"
          />
        )}
      </MaxWidthContainer>
    </Container>
  );
};
